<script>    
    import Zoom from "./zoom/Zoom.svelte";

    export let image;

</script>

<div id="img-{image.id}" class="w-full h-full flex-shrink-0 relative overflow-hidden snap-center snap-both snap-mandatory" >
    <Zoom {...image} /> 
</div>